
    import { Component, Prop, Vue } from 'vue-property-decorator';
    import { mapActions, mapState } from 'vuex';
    import Arbeitsplatz from '@/types/Arbeitsplatz';

    @Component({
        computed: {
            ...mapState('authentication', ['arbeitsplaetze']),
        },
        methods: {
            ...mapActions('globals', ['saveArbeitsplatzAndPrintOrGetCardInfo']),
        },
    })
    export default class ArbeitsplatzhinweisDialog extends Vue {
        @Prop() visible!: boolean;

        public arbeitsplatz: Arbeitsplatz | null = null;
    }
